export const GetAgreementDocuments = gql`
    query GetAgreementDocuments($applicationId: Int!) {
        agreementDocuments(applicationId: $applicationId) {
            id
            name
        }
    }
`;

export const GET_AGREEMENT_DOCUMENT_PDF = gql`
    query getAdobeSignDocumentPdf($input: GetAdobeSignDocumentPdfInput!) {
        getAdobeSignDocumentPdf(input: $input) {
            downloadLink
            pdfBytes
        }
    }
`;

export const GET_SEPA_DD_MANDATE_AGREEMENTS = gql`
    query GetSepaMandates($filters: SepaMandateFilterInput!) {
        getSepaMandates(filters: $filters) {
            data {
                id
                agreementId
                documentId
                status
                accountNumber
                tradingName
                contactName
                sentToEmail
                addedByName
            }
            totalCount
        }
    }
`;
